import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import EditButton from '../../../v2/buttons/EditButton';
const ShipmentValue = ({ dataTestId = 'span-54624', value, editable, onEdit, }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { "data-testid": "div-c39f514f", className: "flex items-center space-x-2" },
        React.createElement("span", { "data-testid": dataTestId }, value || t('NOT_SET')),
        editable && (React.createElement(EditButton, { dataTestId: "EditButton-e6b0296b", onClick: onEdit }))));
};
ShipmentValue.propTypes = {
    dataTestId: PropTypes.string,
    value: PropTypes.string,
    editable: PropTypes.bool,
    onEdit: PropTypes.func.isRequired,
};
ShipmentValue.defaultProps = {
    dataTestId: 'span-54624',
    value: '',
    editable: false,
};
export default ShipmentValue;
